export default __webpack_public_path__ + "static/media/emojiwindle.a6f499d3.png";